import { defineMessages } from "react-intl";

export const messages = defineMessages({
  integrations: {
    id: "MaTR88",
    defaultMessage: "Integrations",
    description: "header",
  },
  forkOnGithub: {
    id: "zmnGkp",
    defaultMessage: "Fork on GitHub",
    description: "button",
  },
  releaseComingSoon: {
    id: "oGIPb7",
    defaultMessage: "Coming soon ({releaseDate})",
    description: "information",
  },
  installationCloudOnly: {
    defaultMessage: "Use Siyool Cloud to access Siyool Apps",
    description: "description",
    id: "pJwwE1",
  },
});
